import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { LEFT, RIGHT, UP, ENTER, EXIT } from '../util/remoteButtons';
import { connect } from 'react-redux';
import bdReq from '../network/bdReq';
import bdAuth from '../network/bdAuth';

import { fetchDevice } from '../store/actions/deviceActions';
import { fetchUser } from '../store/actions/userActions';
import { mobileDeviceId } from '../store/actions/appActions';
import {
  fetchFeaturedPlaylist,
  fetchHomePlaylist,
  fetchActivePlaylist,
  fetchMyPlaylist,
} from '../store/actions/playlistActions';
import { fetchSubscription } from '../store/actions/subscriptionActions';
import { FETCH_DEVICE_SUCCESS } from '../store/constants/deviceConstants';
import { fireAnalytics } from './utils';
import Artwork from '../components/FullScreenCarouselItem';
const { filterPlaylist } = require('@blackdove/bd-app-package').functions;
import { withNavigate } from '../util/withNavigate';

export class Connect extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        selectedBtn: 'skip',
        artworks: [],
        artwork: null,
        pairOverlay: true,
        navigating: false,
        navTimeout: null,
        current: 0,
        downloadedArtNames: [],
        currentDownloads: 0,
        popup: false,
        styles: this.getStyles()
      }
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.handleUpdateDownloads = this.handleUpdateDownloads.bind(this);
      this.pairing = this.pairing.bind(this);
      this.pair = React.createRef();
      this.skip = React.createRef();
      this.code = React.createRef();
      this.pairInterval = setInterval(() => this.pairing(), 3000);
      this.artworkIntervalTime = null;
      this.playlistId = screen.orientation.type === 'landscape-primary' ?
                      'Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx' :
                      'b1f908bb-9722-4e70-ac5c-653ad45ee3ea'
    }

    componentDidMount() {
      fireAnalytics('Page', 'Pair Page Loaded');
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
      this.fetchPlaylist();
      
      setTimeout(() => {
        this.skip.current?.focus();
      }, 500);
      this.artworkIntervalTime = setInterval(() => this.navigate('next'), 120000);
    }

    getStyles = () => {
      const isPortrait = window.innerWidth <= window.innerHeight;
      return {
        btnWrapperWidth: isPortrait ? '60%' : '30%',
      };
    };

    handleResize = () => {
      this.setState({ styles: this.getStyles() });
    };

    goToPage = (pageLink) => {
      const { navigate } = this.props;
      navigate(pageLink);
    };

    handleKeyDown(e){
        console.log(e.which)
        e.stopPropagation();
        e.preventDefault();
        switch(e.which){
            case RIGHT:
                if(this.state.selectedBtn === 'pair'){
                  if(this.state.navigating){
                      this.navigate('next');
                  }else{
                      this.setState({navigating : true})
                  }
                }
                break;
            case LEFT:
                if(this.state.selectedBtn === 'pair'){
                  if(this.state.navigating){
                      this.navigate('prev');
                  }else{
                      this.setState({navigating : true})
                  }
                }
                break;
            case ENTER:
                if(this.state.selectedBtn === 'skip'){
                  this.setState({pairOverlay : false});
                  this.setState({selectedBtn : 'pair'});
                }
                break;
            case UP:
                if(this.state.selectedBtn === 'pair' && this.state.pairOverlay === false){
                  this.setState({pairOverlay : true});
                  this.setState({selectedBtn : 'skip'});
                }
                break;
            case EXIT:
                fireAnalytics('User Action', 'Quitting App on Pair page');
                tizen.application.getCurrentApplication().exit();
                break;
        }
    }

    async fetchPlaylist() {
      const that = this;
      try {
        const fetchActivePlaylist = await that.props.fetchActivePlaylist(
          this.playlistId
        );
        if (fetchActivePlaylist.errors === 'Error') {
          this.navigateToError();
          return;
        }
        const artworks = fetchActivePlaylist.payload.artwork;
        that.setState((prevState) => ({ artworks: artworks }));
      } catch (error) {
        console.log("New pair fetchActivePlaylist error",error)
      }
    }

    handleNavigationSetup = () => {
      clearInterval(this.artworkIntervalTime);
      clearTimeout(this.state.navTimeout);
      
      this.resetInterval();
      
      // Set navigation timeout
      const navTimeout = setTimeout(() => {
        this.setState(prevState => ({ ...prevState, navigating: false }));
      }, 4000);

      return navTimeout;
    };

    manipulateArtworks = (direction) => {
      const artworks = this.state.artworks.slice(0);

      if (direction === 'prev') {
        artworks.unshift(artworks.pop());
      } else {
        artworks.push(artworks.shift());
      }

      return artworks;
    };

    navigate = (direction) => {
      const navTimeout = this.handleNavigationSetup();
      const artworks = this.manipulateArtworks(direction);

      this.setState(prevState => ({
        ...prevState,
        navTimeout,
        artworks
      }));
    };

    resetInterval = () => {
      clearInterval(this.artworkIntervalTime);
      this.artworkIntervalTime = setInterval(() => {
        setTimeout(() => {
          this.navigate('next');
        }, 800);
      }, 120000);
    }

    handleUpdateDownloads(fileName) {
      if (fileName === 0) {
        this.setState({
          downloadedArtNames: [],
          currentDownloads: 0
        });
      } else {
        this.setState(prevState => {
          if (!prevState.downloadedArtNames.includes(fileName)) {
            const updatedNames = [...prevState.downloadedArtNames, fileName];
            return {
              downloadedArtNames: updatedNames,
              currentDownloads: updatedNames.length
            };
          }
          return null;
        });
      }
      console.log("Downloads counted",this.state.currentDownloads)
    }

    playOfflineArtworks = (artworks) => {
      this.setState({
        artworks,
        current: 0,
      });
    };

    playDownloadedArtworkOnly = (offlineArtworkList) => {
      let offlineArtworksName = [];
      for(let artwork of offlineArtworkList){
        let obj = {};
        obj.name = artwork.name.toString().split('.mp4')[0];
        offlineArtworksName.push(obj);
      }
      filterPlaylist(this.artworks, offlineArtworksName, false)
        .then(finalArtworksList => {
          this.playOfflineArtworks(finalArtworksList);
        });
    };

    getCurrentArtworkName() {
      const { artworks } = this.state;
      if (!artworks || artworks.length == 0) return '';

      return artworks[this.state.current].name;
    }

    getCurrentArtworkArtistName() {
      const { artworks } = this.state;
      if (!artworks || artworks.length == 0) return '';

      const { current } = this.state;
      if (artworks[current]?._embedded?.artist?.givenName && artworks[current]?._embedded?.artist?.surname)
        return `${artworks[current]?._embedded?.artist?.givenName} ${artworks[current]?._embedded?.artist?.surname}`;
      else if (artworks[current]?.artist?.displayName) return `${artworks[current]?.artist?.displayName}`;
      else return '';
    }

    showPermanentPopup() {
      console.log("Cannot play artwork")
    }

    async pairing() {
      try {
        const deviceResult = await this.fetchAndValidateDevice();
        if (!deviceResult) return; // Error already handled

        if (deviceResult.type === FETCH_DEVICE_SUCCESS) {
          await this.handleSuccessfulPairing(deviceResult.payload);
        }

      } catch (e) {
        console.error('Error in pairing:', e);
        this.navigateToError();
      }
    }

    // Fetch device and handle validation
    async fetchAndValidateDevice() {
      const deviceResult = await this.props.fetchDevice(this.props.app.SCAPDeviceId);

      if (deviceResult.errors === 'Error') {
        this.navigateToError();
        return null;
      }

      return deviceResult;
    }

    // Handle successful pairing flow
    async handleSuccessfulPairing({ email: emailId, userId }) {
      // Clear pairing interval and fire analytics
      clearInterval(this.pairInterval);
      fireAnalytics('Pair', 'Display Paired Successfully', emailId);

      // Authenticate user
      await this.authenticateUser({ emailId, userId });

      // Fetch all required data
      await this.fetchAllPairingData();

      // Navigate to playlist
      this.navigateToPlaylist();
    }

    // Authenticate user with mobile device ID and email login
    async authenticateUser({ emailId, userId }) {
      await this.props.mobileDeviceId(userId);

      const response = await bdReq.post('/emailLogin', { emailId });
      if (response.success) {
        bdAuth._storeToken(response.body);
      }
    }

    // Fetch all required data for pairing with centralized error handling
    async fetchAllPairingData() {
      const fetchOperations = [
        { name: 'User', method: () => this.props.fetchUser() },
        { name: 'Subscription', method: () => this.props.fetchSubscription() },
        { name: 'Featured Playlist', method: () => this.props.fetchFeaturedPlaylist() },
        { name: 'My Playlist', method: () => this.props.fetchMyPlaylist() },
        { name: 'Home Playlist', method: () => this.props.fetchHomePlaylist() },
        { name: 'Active Playlist', method: () => this.props.fetchActivePlaylist(this.playlistId) }
      ];

      for (const { name, method } of fetchOperations) {
        const result = await method();

        if (result.errors === 'Error') {
          console.error(`Error fetching ${name}:`, result);
          this.navigateToError();
          throw new Error(`Failed to fetch ${name}`);
        }

        // Handle special case for subscription (commented out in original)
        // if (name === 'Subscription' && result?.payload?.subscription?.subscriptionType === 'FREE') {
        //   setTimeout(() => this.goToPage('/subscription'), 10);
        //   throw new Error('Free subscription detected');
        // }

        // Handle successful active playlist fetch
        if (name === 'Active Playlist' && result.type === "FETCH_ACTIVE_PLAYLIST_SUCCESS") {
          fireAnalytics('Navigation', 'Setup Complete, navigating to player');
          return; // Exit early on success
        }
      }
    }

    // Navigate to playlist with popup
    navigateToPlaylist() {
      this.setState({ popup: true });

      setTimeout(() => {
        this.setState({ popup: false });
        this.goToPage(`/playlist/${this.playlistId}`);
      }, 3000);
    }

    // Helper method for consistent error navigation
    navigateToError() {
      setTimeout(() => {
        this.goToPage('/error');
      }, 10);
    }

    componentWillUnmount() {
      clearInterval(this.artworkIntervalTime);
      window.removeEventListener('resize', this.handleResize);
    }

    render(){
        const { artworks, current, styles } = this.state;
        return(
            <div
                className="PairWrapper"
                onKeyDown={this.handleKeyDown}
                >
                {this.state.navigating ? (
                  <div className="fullscreenNavOverlay">
                    <div
                      className="btn btn--circle navLeft"
                    >
                      <span tabIndex="2" className="ion-ios-arrow-back btn--arrow" />
                    </div>
                    <div>
                      <p
                        className="h--no-spacing"
                        style={{
                          color: 'white',
                          textTransform: 'uppercase',
                          fontSize: window.innerWidth <= window.innerHeight ? '2.4rem' : '1.8rem',
                          fontStyle: 'normal',
                          fontWeight: '600',
                          letterSpacing: '0em',
                          textAlign: 'left',
                          lineHeight: '3rem',
                          marginBottom: window.innerWidth <= window.innerHeight ? '2.4rem' : '1.4rem',
                        }}
                      >
                        {this.getCurrentArtworkName()}
                      </p>
                      <p
                        className="h--normalize-weight"
                        style={{
                          color: 'white',
                          fontSize: window.innerWidth <= window.innerHeight ? '1.8rem' : '1.5rem',
                          marginBottom: 0,
                          textAlign: 'center',
                        }}
                      >
                        {this.getCurrentArtworkArtistName()}
                      </p>
                    </div>
                    <div
                      className="btn btn--circle navRight"
                    >
                      <span tabIndex="3" className="ion-ios-arrow-forward btn--arrow" />
                    </div>
                  </div>
                ): null}
                <div className="PairplayerWrapper">
                  {artworks.length !== 0 ? (
                    artworks.map((item, idx) => (
                      idx === current &&(
                            <Artwork 
                              isCurrent={idx == current}
                              artwork={item}
                              setCurrentArtworkId={(item) => this.setCurrentArtworkId(item)}
                              navigate={this.navigate}
                              artworks={artworks}
                              handleUpdateDownloads={this.handleUpdateDownloads}
                              playDownloadedArtworkOnly={this.playDownloadedArtworkOnly}
                              unpaired={true}
                              showPermanentPopup={() => this.showPermanentPopup()}
                            />)
                      ))) : null}
                </div>
                <div 
                  className="PairLogoWrapper"
                  style = {this.state.pairOverlay ? {opacity:'1'} : {opacity:'0'}}
                  >
                    <img
                      style={{ width: window.innerWidth < window.innerHeight ? "30%" : "18%" }}
                      src="/assets/img/blackdove-logo-2020.png"
                      alt=""
                    />
                    <div className="PairQrWrapper">
                        <QRCodeSVG
                          value={`https://app.blackdove.com/device/${this.props.app.SCAPDeviceId}`}
                          size={350}
                          className="QRCodenew"
                        />
                        <img 
                          className="PairLogoIcon" 
                          src="/assets/img/Logo.png" 
                          alt="" 
                          style={{ top: window.innerWidth < window.innerHeight ? "46.5%" : "48%" }}
                          />
                        <div className="PairCodeWrapper">
                            {this.props.app.SCAPDeviceId}
                        </div>
                    </div>
                    <div 
                      className="PairBtnWrapper"
                      style = {{
                        width: styles.btnWrapperWidth
                      }}
                      >
                        <button 
                            className="PairNewBtn"
                            ref={this.skip}
                            >SKIP</button>
                    </div>
                </div>
                <div className="timedPopup" style={this.state.popup ? { opacity: '1' } : { opacity: '0' }}>
                  Device Paired Successfully
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
  mobileDeviceId: (mobileId) => dispatch(mobileDeviceId(mobileId)),
  fetchDevice: (deviceId) => dispatch(fetchDevice(deviceId)),
  fetchUser: () => dispatch(fetchUser()),
  fetchSubscription: () => dispatch(fetchSubscription()),
  fetchFeaturedPlaylist: () => dispatch(fetchFeaturedPlaylist()),
  fetchMyPlaylist: () => dispatch(fetchMyPlaylist()),
  fetchHomePlaylist: () => dispatch(fetchHomePlaylist()),
  fetchActivePlaylist: (targetPlaylistId) => dispatch(fetchActivePlaylist(targetPlaylistId)),
});
export default connect((state) => {
  const { app } = state;
  return {
    app
  };
}, mapDispatchToProps)(withNavigate(Connect));